import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CoursesSection = () => {
  const [selectedDuration, setSelectedDuration] = useState("All");
  const [hoveredDuration, setHoveredDuration] = useState(null);
  const [courses, setCourses] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [loading, setLoading] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const navigate = useNavigate();

  const durationBtnStyle = (duration) => {
    const isActive = selectedDuration === duration;
    const isHovered = hoveredDuration === duration && !isActive;
    return {
      ...categoryBtnStyle(duration),
      border: isActive ? "none" : "1.5px solid #002c6a",
      background: isActive ? "linear-gradient(135deg, #002c6a, #1a5fb4)" : isHovered ? "#002c6a" : "#fff",
      color: isActive || isHovered ? "#fff" : "#002c6a",
      boxShadow: isActive ? "0 8px 20px rgba(0, 44, 106, 0.25)" : "none",
    };
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch("https://api.npoint.io/debb4302f8e0f28dafe6");
        if (!response.ok) throw new Error("Failed to fetch");
        const data = await response.json();
        if (Array.isArray(data.courses)) {
          setCourses(data.courses);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const categories = ["All", ...new Set(courses.map((course) => course.category))];
  const durations = ["All", ...new Set(courses.map((c) => c.duration?.trim()))];

  const filteredCourses = courses.filter((course) => {
    const categoryMatch = selectedCategory === "All" || course.category === selectedCategory;
    const durationMatch = selectedDuration === "All" || course.duration === selectedDuration;
    return categoryMatch && durationMatch;
  });

  // const filteredCourses =
  //   selectedCategory === "All"
  //     ? courses
  //     : courses.filter((course) => course.category === selectedCategory);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <p>Loading Courses...</p>
      </div>
    );
  }

  const cardStyle = (index) => ({
    background: "#ffffff",
    borderRadius: "18px",
    overflow: "hidden",
    border: `1px solid ${hoveredIndex === index ? "#c2d4f0" : "#f1f5f9"}`,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
    transition:
      "transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.35s cubic-bezier(0.23, 1, 0.32, 1), border-color 0.35s ease",
    transform:
      hoveredIndex === index
        ? "translateY(-10px) scale(1.02)"
        : "translateY(0) scale(1)",
    boxShadow:
      hoveredIndex === index
        ? "0 24px 48px rgba(0, 44, 106, 0.13)"
        : "0 10px 25px rgba(0, 0, 0, 0.05)",
    cursor: "pointer",
  });

  const imgStyle = (index) => ({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
    transform: hoveredIndex === index ? "scale(1.06)" : "scale(1)",
  });

  const categoryBtnStyle = (category) => {
    const isActive = selectedCategory === category;
    const isHovered = hoveredCategory === category && !isActive;
    return {
      border: isActive ? "none" : "1.5px solid #002c6a",
      background: isActive
        ? "linear-gradient(135deg, #002c6a, #1a5fb4)"
        : isHovered
        ? "#002c6a"
        : "#fff",
      color: isActive || isHovered ? "#fff" : "#002c6a",
      padding: "6px 18px",
      borderRadius: "30px",
      fontSize: "0.9rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.23, 1, 0.32, 1)",
      boxShadow: isActive
        ? "0 8px 20px rgba(0, 44, 106, 0.25)"
        : "none",
    };
  };

  return (
    <div className="container-fluid course py-5 mb-5 p-2">
      <div className="container">

        {/* Filter Bar */}
        <div className="category-filter mb-5">
          {categories.map((category, index) => (
            <button
              key={index}
              style={categoryBtnStyle(category)}
              onClick={() => setSelectedCategory(category)}
              onMouseEnter={() => setHoveredCategory(category)}
              onMouseLeave={() => setHoveredCategory(null)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Duration Filter Bar */}
        <div className="category-filter mb-5">
          {durations.map((duration, index) => (
            <button
              key={index}
              style={durationBtnStyle(duration)}
              onClick={() => setSelectedDuration(duration)}
              onMouseEnter={() => setHoveredDuration(duration)}
              onMouseLeave={() => setHoveredDuration(null)}
            >
              {duration}
            </button>
          ))}
        </div>

        {/* Course Cards */}
        {filteredCourses.length === 0 ? (
          <div className="text-center py-5">
            <p style={{ color: "#94a3b8", fontSize: "1.05rem" }}>No courses found</p>
          </div>
        ) : (
          <div className="row g-4 justify-content-center">
            {filteredCourses.map((course, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() =>
                  navigate("/course/details/" + course.slug, {
                    state: { courseData: course },
                  })
                }
              >
                <div style={cardStyle(index)}>

                  {/* Top accent bar — slides in from left on hover */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: "3px",
                      background: "linear-gradient(90deg, #002c6a, #1a5fb4)",
                      transform:
                        hoveredIndex === index ? "scaleX(1)" : "scaleX(0)",
                      transformOrigin: "left",
                      transition:
                        "transform 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
                      zIndex: 3,
                    }}
                  />

                  {/* Image */}
                  <div
                    style={{
                      height: "220px",
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <img
                      src={course.image}
                      alt={course.course_name}
                      style={imgStyle(index)}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      padding: "22px",
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <h4
                      style={{
                        fontSize: "1.05rem",
                        fontWeight: 700,
                        color: hoveredIndex === index ? "#002c6a" : "#1f2937",
                        marginBottom: "14px",
                        lineHeight: 1.4,
                        transition: "color 0.3s ease",
                      }}
                    >
                      {course.course_name}
                    </h4>

                    <div className="course-meta">
                      <p style={{ marginBottom: "8px" }}>
                        <i
                          className="fas fa-clock"
                          style={{
                            color: hoveredIndex === index ? "#002c6a" : "#1e3a8a",
                            marginRight: "8px",
                            transition: "color 0.3s ease",
                          }}
                        ></i>
                        <strong>Duration:</strong>&nbsp;{course.duration}
                      </p>
                      <p style={{ marginBottom: 0 }}>
                        <i
                          className="fas fa-calendar-alt"
                          style={{
                            color: hoveredIndex === index ? "#002c6a" : "#1e3a8a",
                            marginRight: "8px",
                            transition: "color 0.3s ease",
                          }}
                        ></i>
                        <strong>Intakes:</strong>&nbsp;{course.intakes}
                      </p>
                    </div>
                  </div>

                  {/* Bottom theme color accent — thickens on hover */}
                  <div
                    style={{
                      height: hoveredIndex === index ? "6px" : "8px",
                      width: "100%",
                      backgroundColor: course.theme_color || "#002c6a",
                      transition: "height 0.3s ease",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CoursesSection;